import { _ as n } from "../lodash-26d68caa.js";
const o = (t) => t == null, i = (t) => !o(t), m = (t) => n.isEmpty(t) ? void 0 : Number(t), c = (t) => o(t) ? "" : String(t);
export {
  c as convertNumberToString,
  m as convertStringToNumber,
  o as isEmpty,
  i as notEmpty
};
//# sourceMappingURL=object.utils.js.map
